import { useTextes } from '@common/config';
import { z } from 'zod';

const t = useTextes('Inscription', 'Récapitulatif');

export const additionalInfoSchema = z.object({
  apprentiNumber: z
    .coerce
    .number()
    .min(1, { error: t['COMP_MES3'] }),
  nda: z
    .string()
    .optional(),
});